import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { UniversalCard } from '@components/core-ui/UniversalCard';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { useAPI } from '@providers/useAPI';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GetSettingsResponseSetting } from 'app/API';
import { adminSettingsKeys } from 'app/queries/adminSettings/adminSettingsKeys';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';

import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import PencilSvg from '@components/icons/Pencil.svg';
import { createFetchAdminSettingsQueryFn } from '../../api/fetchAdminSettings';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { me } = useAuthContext();
  const { call } = useAPI();
  const queryClient = useQueryClient();
  const { openModal } = useModalContext();

  const settingsQuery = useQuery({
    queryKey: adminSettingsKeys.settings(),
    queryFn: createFetchAdminSettingsQueryFn(call),
  });
  const settings = settingsQuery.data;
  const isLoading = settingsQuery.isFetching;

  const openEditSettingModal = (e: React.MouseEvent<HTMLButtonElement>, setting: GetSettingsResponseSetting) => {
    e.stopPropagation();
    openModal(ModalNamesEnum.AdminEditSetting, {
      setting,
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: adminSettingsKeys.settings() });
      },
    });
  };

  return (
    <Wrapper>
      <LinearProgressLoader active={isLoading} />
      <div className="line">
        <UniversalCard
          name="Environment"
          content={
            <>
              <p>Environment:</p>
              <p>{settings?.env.ENVIRONMENT}</p>
            </>
          }
        />
        <UniversalCard
          name="AWS Bucket"
          content={
            <>
              <p>AWS Bucket:</p>
              <p>{settings?.env.AWSBUCKET}</p>
            </>
          }
        />
      </div>

      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            {(settings?.settings ?? []).map((data: GetSettingsResponseSetting) => {
              const isVsBilling = me?.roles?.includes('ROLE_BILLING_ADMIN');

              return (
                <Tr key={data.name}>
                  <Td>
                    <p className="cell">{data?.name}</p>
                  </Td>
                  <Td>
                    <p className="cell">
                      {data?.value}
                      {!isVsBilling && data?.name === 'SIGNUP_CREDIT_AMOUNT' ? null : (
                        <IconButtonClean
                          type="button"
                          title="Edit setting"
                          className="ml-[10px]"
                          onClick={(e) => openEditSettingModal(e, data)}
                        >
                          <PencilSvg />
                        </IconButtonClean>
                      )}
                    </p>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Wrapper>
  );
};
